import "./style.scss";

export const Error = () => {
  return <div className="error-page">Something when wrong</div>;
};
